import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { urlServer } from '../global_constants';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  configPath = urlServer.concat("/v1/settings");
  reviveMailPath = urlServer.concat("/v1/settings/authorize");
  reviveCloseDayNotifPath =  urlServer.concat("/v1/settings/authorize/close_day_notif");
  deadlineSettingPath = urlServer.concat("/v1/settings/visitDeadline");
  fieldSettingPath = urlServer.concat("/v1/settings/fieldVisibility");
  notifsPeriodsCaSettingPath = urlServer.concat("/v1/settings/ca_alerts/toggle");


  copyRelanceSubject:Subject<any>;
  closeDayNotifSubject:Subject<any>;
  deadlineSubject:Subject<any>;
  visibilitySubject:Subject<any>;
  public get token() : string|null {
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
    return localStorage.getItem("token");
    return sessionStorage.getItem("token");   

  }

  constructor(private httpClient:HttpClient) {
    this.copyRelanceSubject=new Subject();
    this.closeDayNotifSubject=new Subject();
    this.deadlineSubject=new Subject();
    this.visibilitySubject=new Subject();
   }

  activeOrDesactiveReviveMailCopy(status:any){
    this.copyRelanceSubject=new Subject();
    const requestCopyRevive = {
      "parameter": status
    };
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    this.httpClient.post(this.reviveMailPath,requestCopyRevive,{headers: header}).subscribe((response: any) => {
        this.copyRelanceSubject.next(response);
        this.copyRelanceSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  activeOrDesactiveCloseDayNotifs(parameter:any){
    this.closeDayNotifSubject=new Subject();
    const requestCloseDayNotif = {
      "parameter": parameter
    };
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    this.httpClient.post(this.reviveMailPath,requestCloseDayNotif,{headers: header}).subscribe((response: any) => {
        this.closeDayNotifSubject.next(response);
        this.closeDayNotifSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  setVisitDeadline(value:any){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    this.httpClient.post(this.deadlineSettingPath,value,{headers: header}).subscribe((response: any) => {
      this.deadlineSubject.next(response);
      if (response.code === "45859d1ba9e878f62c51935e3119d7ad") {
        localStorage.setItem("visitDeadline", value);
      }
      // this.deadlineSubject.complete();
    },
    error => {
      console.error('There was an error!', error);
    }
  );
  }

  setFieldVisibility(reqBody:any){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    this.httpClient.post(this.fieldSettingPath,reqBody,{headers: header}).subscribe((response: any) => {
      this.visibilitySubject.next(response);
      // this.deadlineSubject.complete();
    },
    error => {
      console.error('There was an error!', error);
    }
  );
  }

  getConfig(){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.get<any>(`${this.configPath}`, {headers: header});
  }

  activeOrDesactiveNotifsCA(enabled: boolean, period?: string): Observable<any>{
    this.closeDayNotifSubject = new Subject<any>();
    const requestBody: any = {
      enabled: enabled
    };
    // Ajouter la période si fournie
    if (period) {
      requestBody.period = period;
    }
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.set('authorization', 'Bearer ' + this.token);
    headers = headers.set('Content-Type', 'application/json');
    this.httpClient.post<any>(
      this.notifsPeriodsCaSettingPath,requestBody,{ headers: headers }).subscribe(
      (response: any) => {
        this.closeDayNotifSubject.next(response);
        this.closeDayNotifSubject.complete();
      },
      error => {
        console.error('Erreur lors du toggle des alertes CA:', error);
        this.closeDayNotifSubject.error(error);
      }
    );
    return this.closeDayNotifSubject.asObservable();
  }
}
